import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

import LoginForm from "@/pages/LoginForm.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import Account from "@/pages/Account.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Typography from "@/pages/Typography.vue";
import Products from "@/pages/Products.vue";
import ScriptBuilder from "@/pages/ScriptBuilder.vue";
import Settings from "@/pages/Settings.vue";

const routes = [
    {
        path: "/login",
        name: "login",
        component: LoginForm,
    },

    {
        path: "/",
        component: DashboardLayout,
        redirect: "/dashboard",
        children: [
            {
                path: "dashboard",
                name: "dashboard",
                component: Dashboard,
            },
            {
                path: "notifications",
                name: "notifications",
                component: Notifications,
            },
            {
                path: "icons",
                name: "icons",
                component: Icons,
            },
            {
                path: "account",
                name: "account",
                component: Account,
            },
            {
                path: "settings",
                name: "settings",
                component: Settings,
            },

            {
                path: "script-builder",
                name: "script-builder",
                component: ScriptBuilder,
            },
            {
                path: "products",
                name: "products",
                component: Products,
            },

        ],


    },

    {
        path: '/logout',
        name: 'logout',
      },
      
      
    { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
